import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=6de824be&scoped=true&"
import script from "./Configuracion.vue?vue&type=script&lang=js&"
export * from "./Configuracion.vue?vue&type=script&lang=js&"
import style0 from "./Configuracion.vue?vue&type=style&index=0&id=6de824be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de824be",
  null
  
)

export default component.exports